module.exports = __webpack_public_path__ + "static/img/Thinkpad_L390.d6124ee3.png";